import { render, staticRenderFns } from "./WorkspaceCreate.vue?vue&type=template&id=3f545c86"
import script from "./WorkspaceCreate.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports